module.exports = __webpack_public_path__ + "assets/img/QRlogoB.72ad824924ba9e52c1d819176e0b19ae.svg";